import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo1 from './csrl_logo.png';
import DateTime from './datetime';
import './header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="logo-and-title">
        <a href="/#home">
          <img src={logo1} alt="NITK Logo" className="logo" />
        </a>
        <div className="titles">
          <h1 className="lab-title">Cyber Security Research Lab</h1>
          <h1 className="dept-title">Department of Computer Science & Engineering</h1>
          <h1 className="dept-title">National Institute of Technology Karnataka, Surathkal</h1>
        </div>
      </div>
      <div className="top-right">
        <strong><DateTime /></strong>
      </div>

      {/* Hamburger (you can remove this if you don’t want it) */}
      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>

      <nav className={menuOpen ? 'nav open' : 'nav'}>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li className="dropdown">
            <span>Research</span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/research/focus-area">
                  Focus Area <span className="arrow">➤</span>
                </Link>
              </li>
              <li>
                <Link to="/research/projects">
                  Projects <span className="arrow">➤</span>
                </Link>
              </li>
              <li>
                <Link to="/research/people">
                  People <span className="arrow">➤</span>
                </Link>
              </li>
              <li>
                <Link to="/research/publications-patents">
                  Publications & Patents <span className="arrow">➤</span>
                </Link>
              </li>
            </ul>
          </li>
          <li><Link to="/5glab">5G Usecase Lab</Link></li>
          <li className="dropdown">
            <span>Applications</span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/iot-dashboard">
                  DFIR App <span className="arrow">➤</span>
                </Link>
              </li>
              <li>
                <Link to="/digital-twin">
                  Digital Twin <span className="arrow">➤</span>
                </Link>
              </li>
              <li>
                <a href="https://csrl.l1.nitk.ac.in/campus-navigation/" target="_blank" rel="noopener noreferrer">
                  Campus Navigation <span className="arrow">➤</span>
                </a>
              </li>
            </ul>
          </li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
